import { Link, LinkProps, Navbar } from '@sketch/components'
import React from 'react'

import { useScrollTop } from '@sketch/utils'
import { SKETCH_WEBSITE } from '@sketch/env-config'

import { Header, LogoWrapper, Logo } from './IndexLayout.styles'
import { useUserSignedIn } from '../../user'
import { routes } from '../../routes'

export interface IndexLayoutHeaderProps {
  disableLogoLink?: boolean
}

export const IndexLayoutHeader: React.FC<IndexLayoutHeaderProps> = ({
  disableLogoLink,
  children,
}) => {
  const { isScrollTop } = useScrollTop()
  const isUserSignIn = useUserSignedIn()

  const linkProps = (
    isUserSignIn
      ? { to: routes.ENTRY.create({}) }
      : {
          href: `${SKETCH_WEBSITE}/home`,
          external: true,
        }
  ) satisfies LinkProps

  return (
    <Header data-scrolltop={isScrollTop}>
      <LogoWrapper data-testid="sketch-logo">
        {disableLogoLink ? (
          <Logo />
        ) : (
          <Link {...linkProps}>
            <Logo />
          </Link>
        )}
      </LogoWrapper>
      <Navbar.Section align="start">{children}</Navbar.Section>
    </Header>
  )
}
